import React from 'react'
import { styled } from '@mui/material/styles'
import Text from '@/components/Text'

const PageWrapper = styled('div')(() => ({
  display: 'flex',
  width: '100vw',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '58px',
}))

function Empty() {
  return (
    <PageWrapper className='empty'>
      <Text size='xl'>404 NOT FOUND</Text>
    </PageWrapper>
  )
}

export function ErrorPage() {
  return (
    <PageWrapper className='empty'>
      <Text size='xl'>500 服务器错误</Text>
    </PageWrapper>
  )
}

export default Empty
